<template>
  <div class="app-container">
    <Title :data="data"></Title>
    <div style="display: flex">
      <div style="width: 80%">
        <batchadd
          title="讲义"
          text="讲义"
          :dataList="form.handout"
          @edit="clickUpload('handout')"
          @update="getDetail()"
          style="margin-bottom: 20px"
        ></batchadd>
        <batchadd
          title="教案"
          text="教案"
          :dataList="form.lesson_plan"
          @edit="clickUpload('lesson_plan')"
          @update="getDetail()"
          style="margin-bottom: 20px"
        ></batchadd>
        <batchadd
          title="音频/视频"
          text="音频/视频"
          :dataList="form.video_audio"
          @edit="clickUpload('video_audio')"
          @update="getDetail()"
          style="margin-bottom: 20px"
        ></batchadd>
      </div>
      <Uptips style="width: 20%"></Uptips>
    </div>
    <div class="bottom_btn">
      <el-button @click="$router.go(-1)">返回</el-button>
      <el-button type="primary" @click="submit" :loading="btnLoading"
        >保存并提交</el-button
      >
    </div>
  </div>
</template>

<script>
import Batch from "@/components/Batch/index.vue";
import request from "@/utils/request";
export default {
  components: {
    Batch,
  },
  data() {
    return {
      data: {},
      form: {},
      listQuery: {
        page: 1,
        limit: 10,
        type: null,
        class_course_id: null,
      },
      selected: false,
      batchAuthDialogVisible: false,
      batchAuthBtnLoading: false,
      btnLoading: false,
      rejectReason: null,
    };
  },
  created() {
    this.data = JSON.parse(this.$route.query.data);
    localStorage.setItem("classdata", JSON.stringify(this.data));

    this.listQuery.type = this.$route.query.type;
    this.listQuery.class_course_id = this.$route.query.class_course_id;

    this.form = {
      handout: {
        id: null,
        class_course_id: this.listQuery.class_course_id,
        type: this.listQuery.type,
        type_key: "handout",
        data: [],
      },
      lesson_plan: {
        id: null,
        class_course_id: this.listQuery.class_course_id,
        type: this.listQuery.type,
        type_key: "lesson_plan",
        data: [],
      },
      video_audio: {
        id: null,
        class_course_id: this.listQuery.class_course_id,
        type: this.listQuery.type,
        type_key: "video_audio",
        data: [],
      },
    };
    this.getDetail();
  },
  methods: {
    clickUpload(e) {
      switch (e) {
        case "handout":
          this.form.handout.is_store = 1;
          break;
        case "lesson_plan":
          this.form.lesson_plan.is_store = 1;
          break;
        case "video_audio":
          this.form.video_audio.is_store = 1;
          break;
      }
    },
    getDetail() {
      request({
        url: "/api/backend/eduAdmin/dataDetail",
        method: "get",
        params: this.listQuery,
      }).then((response) => {
        if (response.data.handout) this.form.handout = response.data.handout;
        if (response.data.lesson_plan)
          this.form.lesson_plan = response.data.lesson_plan;
        if (response.data.video_audio)
          this.form.video_audio = response.data.video_audio;
      });
    },
    submit() {
      if (
        this.form.handout.is_store != 1 &&
        this.form.lesson_plan.is_store != 1 &&
        this.form.video_audio.is_store != 1
      ) {
        this.$alert("请修改或者上传后提交", "提示", {
          confirmButtonText: "确定",
          callback: (action) => {
            return;
          },
        });
      }
      let isup = this.form.handout.data.findIndex(
        (value) => value.name == null
      );
      let isstandard = this.form.lesson_plan.data.findIndex(
        (value) => value.name == null
      );
      let isoutline = this.form.video_audio.data.findIndex(
        (value) => value.name == null
      );
      if (isup != -1 || isstandard != -1 || isoutline != -1) {
        this.$message({
          type: "warning",
          message: "添加后,请上传文件!!",
        });
        return;
      }
      let submitForm = {};
      if (this.form.handout.is_store) {
        submitForm.handout = this.form.handout;
      }
      if (this.form.lesson_plan.is_store) {
        submitForm.lesson_plan = this.form.lesson_plan;
      }
      if (this.form.video_audio.is_store) {
        submitForm.video_audio = this.form.video_audio;
      }
      if (Object.keys(submitForm).length == 0) {
        return;
      }
      // return
      this.btnLoading = true;
      request({
        url: "/api/backend/eduAdmin/dataStore",
        method: "post",
        data: submitForm,
      })
        .then((response) => {
          this.btnLoading = false;
          this.$message({
            type: "success",
            message: "操作成功",
          });
          this.getDetail()
          // this.$router.go(0);
        })
        .catch((err) => {
          this.btnLoading = false;
        });
    },
    handlerTap(v) {
      this.selected = !this.selected;
    },
    handleBatchAuth() {},
    handleClose() {
      this.batchAuthDialogVisible = false;
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.title {
  margin-bottom: 20px;
}
.content {
  width: 50%;
  margin: 0 auto;
  .header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 5px;
  }
  .bottom_row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 100px;
  }
  .bottom {
    display: flex;
  }
}
.bottom_btn {
  display: flex;
  justify-content: center;
}
</style>
